//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import thumbnail from '@/assets/imgs/mindshare.png';
import abstract from '@/assets/imgs/post-abstract.svg';
import { post } from '@/mixins/wp-post';

export default {
  name: 'KnockPost',

  mixins: [post(({ route }) => route.params.slug)],

  async asyncData({ params, payload, $wpJson }) {
    if (payload) {
      return payload;
    }

    const { slug } = params;
    const catNames = [];
    let post;
    let categories = [];
    let posts = [];

    try {
      post = await $wpJson.posts.getBySlug(slug);
      post.categories = post.categories.filter((cat) => cat !== 1);
    }
    catch (err) {
      console.error(err);
    }

    try {
      (categories = await $wpJson.posts.getCats());
    }
    catch (err) {
      console.error(err);
    }

    try {
      ({ posts } = await $wpJson.posts.getPreviews({
        perPage: 2
      }));
    }
    catch (err) {
      console.error(err);
    }

    categories = categories.filter((cat) => cat.count !== 0);

    categories.some((cat, id) => cat.id === 1 && categories.unshift(
      categories.splice(id, 1)[0]
    ));

    categories.forEach((category) => {
      catNames[category.id] = category.name;
    });

    return { post, catNames, posts };
  },

  data() {
    return {
      thumbnail,
      shareOffset: 0
    };
  },

  computed: {
    bannerBg() {
      return `background:  url("${abstract}") no-repeat right top/auto calc(100% - 24px) #131212`;
    }
  },

  mounted() {
    this.computeShareOffset();
    window.addEventListener('resize', this.computeShareOffset);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.computeShareOffset);
  },

  methods: {
    toDate(string) {
      const today = new Date(string);
      return today.toDateString();
    },

    getLogo(post) {
      if (post?.thumbnail?.source_url) {
        return post.thumbnail.source_url;
      }
      return this.thumbnail;
    },

    computeShareOffset() {
      this.shareOffset = this.$refs.article.firstElementChild.offsetHeight + 60;
    }
  }
};
